import { render, staticRenderFns } from "./Guide1.vue?vue&type=template&id=31da4b4e"
import script from "./Guide1.vue?vue&type=script&lang=js"
export * from "./Guide1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports